<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">企业选择</div>
          <el-select size="mini" class="ipt-sty" @change="tenantChange" v-model="page.tenantGuid" placeholder="请选择"  filterable >
              <el-option v-for="item in sendTenantList" :key="item.guid" :label="item.sendTenantName" :value="item.sendTenantGuid">
              </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">指派公司</div>
          <el-select size="mini" class="ipt-sty" v-model="page.maintainTenantGuid" placeholder="请选择"  filterable>
            <el-option
              v-for="item in serviceTenants"
              :key="item.guid" 
              :label="item.tenantName" 
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">指派人员</div>
          <el-input size="mini" v-model="page.staffInfo" class="ipt-sty" placeholder="请输入" :clearable="true"></el-input>
        </el-col>
        
        <el-col :span="6" class="search-btn-box">
            <el-button size="mini" type="expand" @click="searchShow = !searchShow"><i :class="searchShow ? 'el-icon-arrow-up mr5' : 'el-icon-arrow-down mr5'"></i>{{searchShow ? '收起筛选':'更多筛选'}}</el-button>
            <el-button size="mini" type="info" @click="getData(true)">搜索</el-button>
            <el-button size="mini" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
      <div class="search-block mt15" v-if="searchShow">
        <el-row :gutter="24" >
          <el-col :span="6">
            <div class="search-area-div">订单类型</div>
            <el-select size="mini" v-model="page.orderType" placeholder="请选择" class="ipt-sty" :clearable="true">
              <el-option v-for="item in orderTypeList" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">确认日期</div>
            <el-date-picker size="mini" v-model="comfirmTimeList" type="daterange" class="ipt-sty" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">订单状态</div>
            <el-select size="mini" v-model="page.orderState" placeholder="请选择" class="ipt-sty" :clearable="true">
              <el-option v-for="item in orderStateList" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-col>

          <el-col :span="6">
            <div class="search-area-div">客户名称</div>
            <el-input size="mini" v-model="page.customerName" class="ipt-sty" placeholder="请输入" :clearable="true"></el-input>
          </el-col>

          <el-col :span="6" class="mt15">
            <div class="search-area-div" >终端省市区</div>
            <!-- <el-select size="mini" v-model="page.provinces" placeholder="请选择" class="ipt-sty " clearable filterable multiple>
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select> -->
            <el-cascader
              class="ipt-sty"
              ref="cascaderFirst"
              size="mini"
              v-model="addressList"
              collapse-tags
              filterable
              :options="options"
              :props="{ multiple: true, checkStrictly: true }"
            ></el-cascader>
          </el-col>
          <el-col :span="6" class="mt15">
            <div class="search-area-div">确认状态</div>
            <el-select  size="mini" v-model="page.confirmState" placeholder="请选择 " class="ipt-sty" :clearable="true">
              <el-option v-for="item in confirmStateList" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6" class="mt15">
            <div class="search-area-div">数据来源</div>
            <el-select  size="mini" v-model="page.sourceType" placeholder="请选择 " class="ipt-sty" :clearable="true">
              <el-option v-for="item in getCodeListByKey('单据数据来源').filter(item=>item.value === '2' || item.value === '4')" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6" class="mt15">
            <div class="search-area-div">
              <el-tooltip
              class="item"
              effect="light"
              content="1、从ERP同步的数据默认为【未分配】，分配所属人后为【已分配】；2、批量导入的数据所属人为空则为【未分配】，存在所属人则为【已分配】。"
              placement="right-start"
              ><i style="line-height: 34px;" class="el-icon-question"></i></el-tooltip>
              分配状态</div>
            <el-select  size="mini" v-model="page.isAllocated" placeholder="请选择 " class="ipt-sty" :clearable="true">
              <el-option v-for="item in isDistributeList" :key="item.value" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6" class="mt15">
            <div class="search-area-div">商业公司</div>
            <el-input  size="mini" v-model="page.franchiseeName" class="ipt-sty" placeholder="请输入" :clearable="true"></el-input>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">下单日期</div>
            <el-date-picker size="mini" v-model="orderTimeList" type="daterange" class="ipt-sty" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-popover placement="bottom-start" title="【调整订单归属人】用途：" trigger="hover">
          <div>
            如果需要将多笔订单更换给另一个业务员，则可以使用此功能，<br />步骤:勾选需要更换的订单 - 点击[调整订单归属人]
            - 在打开的<br />弹框中选择接替的人-点击[确定] 成功更换!
          </div>
          <el-button slot="reference" size="mini" type="borderBlack" @click="modifyPerson" class="mr10"
            >调整订单归属人</el-button
          >
        </el-popover>
        <el-button size="mini" type="borderGreen" @click="report">导出订单</el-button>
         <el-popover placement="bottom-start" title="【批量调整订单归属人】用途：" trigger="hover">
            <div>
              如果需要更换多个业务员的订单数据，则可以使用此功能.
              <br />
              步骤:先导出订单-在导出表格中更换业务员姓名和手机号.
              <br />
              -点击[批量调整订单归属人] - 导入表格数据 成功更换!
            </div>
            <el-button 
              slot="reference" 
              size="mini" 
              type="borderGreen" 
              class="upload-demo" 
              @click="onShowBatchAdjustmentOrderDialog"
            >
              批量调整订单归属人
            </el-button>
          </el-popover>

         <!-- <el-popover placement="bottom-start" title="【按终端分配】用途：" trigger="hover">
            <div>
              如果订单无法知晓分配给哪位业务员，但是终端指定了业务员，则可以使用此功能进行分配，<br />步骤:<br />1、请在[基础资料管理医院/药店资料管理]
              中分配好各个业务员所负责的终端;<br />2、然后点击[按终端分配]，系统会自动通过第一步建立好的关系分配订单。
            </div>
            <el-button slot="reference" size="mini" class="mr10" type="borderBlack"  @click="automaticAllocation">按终端分配</el-button>
        </el-popover> -->
      </div>
      
      <el-table @selection-change="handleSelectionChange" tooltip-effect="light" ref="filterTable" :data="tableData" stripe border style="width: 100%"
        v-loading="loading" :height="tableHeight">
        <el-table-column type="selection" v-if="tableData && tableData.length != 0"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{  (page.pageIndex - 1) * page.pageSize + scope.$index + 1  }}
          </template>
        </el-table-column>
        <el-table-column prop="orderNo" min-width="140" label="订单编号" show-overflow-tooltip header-align="center"
          align="left"></el-table-column>
        <el-table-column prop="staffName" width="100" label="业务指派人员" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">{{  scope.row.staffName || '-'  }}</template>
        </el-table-column>
        <el-table-column prop="tenantName" min-width="240" label="指派公司" show-overflow-tooltip header-align="center"
          align="left">
          <template slot-scope="scope">{{  scope.row.tenantName || '-'  }}</template>
        </el-table-column>
        <el-table-column prop="customerName" min-width="240" label="客户名称" show-overflow-tooltip header-align="center"
          align="left"></el-table-column>
        <el-table-column prop="franchiseeName" min-width="240" label="商业公司" show-overflow-tooltip header-align="center"
          align="left"></el-table-column>
        <el-table-column prop="venue" width="120" label="省" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.provinceName || '-'}}</template>
        </el-table-column> 
        <el-table-column prop="venue" width="120" label="市" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.cityName || '-'}}</template>
        </el-table-column> 
        <el-table-column prop="venue" width="120" label="区/县" header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.districtName  || '-'}}</template>
        </el-table-column> 
        <el-table-column prop="inputTime" width="120" label="下单日期" header-align="center" align="left">
          <template slot-scope="scope">{{  scope.row.orderTime | getDate  }}</template>
        </el-table-column>
        <el-table-column prop="confirmStateTime" width="120" label="确认日期" header-align="center" align="left">
          <template slot-scope="scope">
            <span v-if="scope.row.confirmStateTime"> {{  scope.row.confirmStateTime | getDate  }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderState" width="80" label="订单状态" header-align="center" align="left">
          <template slot-scope="scope">{{  formatOrderState(scope.row.orderState)  }}</template>
        </el-table-column>
        <el-table-column prop="orderType" width="80" label="订单类型" header-align="center" align="left">
        </el-table-column>
        <el-table-column prop="oldOrderNo" width="130" label="原单号" header-align="center" align="left">
          <template slot-scope="scope">{{  scope.row.oldOrderNo || '-'  }}</template>
        </el-table-column>
        <el-table-column prop="goodsSpecNum" width="100" label="品种数" header-align="center" align="right">
          <template slot-scope="scope">{{  scope.row.goodsSpecNum == null ? '-' : scope.row.goodsSpecNum  }}</template>
        </el-table-column>
        <el-table-column prop="totalAmount" width="150" label="报货金额(元)" header-align="center" align="right">
          <template slot-scope="scope">{{  Number(scope.row.totalAmount) | absoluteValue | numFmt | numDigit  }}</template>
        </el-table-column>
        <el-table-column prop="isAllocated" width="100" label="分配状态" header-align="center" align="left">
          <template slot-scope="scope">
            <a class="txt-color" style="cursor: auto;color: #606266!important;">{{scope.row.isAllocated | isAllocated}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="confirmState" width="100" label="确认状态" header-align="center" align="left">
          <template slot-scope="scope">
            <a class="txt-color" style="cursor: auto;color: #606266!important;">{{scope.row.confirmState | confirmState}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="sourceType" show-overflow-tooltip width="180" label="数据来源" header-align="center" align="left">
          <template slot-scope="scope">
            {{ scope.row.sourceType | commonFilterName('单据数据来源') }}
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="80">
          <template slot-scope="scope">
            <a class="txt-color" @click="detail(scope.row.guid)">报货详情</a>
          </template>
        </el-table-column>


      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff  content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10,20,50, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <el-drawer title="报货详情" :visible.sync="drawer" :direction="direction" size="35%">
      <div class="delivery-details">
        <div class="pl30">
          <p class="t-left font-S16 pic-item">
            <img class="pic-w22 fl mr10" src="../../assets/images/clinic.png" alt=""><b class="fl">{{
               detailData.customerName  }}</b>
          </p>
          <p class="t-left font-S14 pic-item"><img class="pic-w22 fl mr10" src="../../assets/images/address.png"
              alt=""><span class="fl">{{  detailData.address  }}</span></p>
          <p class="t-left font-S14 pic-item"><img class="pic-w22 fl mr10" src="../../assets/images/date.png"
              alt=""><span class="fl">{{  detailData.inputTime | getDate  }}</span> <span class="ml15">{{
               detailData.orderType  }}</span></p>
        </div>
        <div class="variety-information">
          <div class="pl30">
            <p class="t-left font-S16"><b>品种信息</b></p>
            <div class="variety-list" v-for="(item, index) in detailData.productList" :key="index">
              <div class="variety-left fl mr15">
                <img :src="item.picture | filterImgUrl" alt="" />
              </div>
              <div class="variety-right">
                <p class="t-left font-S15">
                  <b>{{  item.goodsName  }}</b>
                </p>
                <p class="t-left">{{  item.goodsSpec  }}</p>
                <p class="t-left">{{  item.producer  }}</p>
                <p class="t-left fontC-red">¥{{  item.price || 0  }}/{{  item.unitStyle  }}</p>
              </div>
              <p class="t-right fontC-bcbec2">小计：数量 {{  item.qty  }} 金额：¥{{  item.amount | absoluteValue | numFmt |
              numDigit

                }}</p>
            </div>
            <p class="t-left total-top">
              共<b class="fontC-4fa1a4">{{  detailData.goodsSpecNum  }}</b>个品种 合计：<b class="fontC-red">¥ {{
                 detailData.totalAmount | absoluteValue | numFmt | numDigit  }}</b>
            </p>
          </div>
        </div>
        <div class="offer-information pb">
          <div class="pl30">
            <p class="t-left font-S16"><b>报货信息</b></p>
            <p class="t-left font-S14"><span>订单编号：</span>{{  detailData.orderNo ||'-'  }}</p>
            <p class="t-left font-S14"><span>下单日期：</span>{{  detailData.inputTime | getDate  }}</p>
            <p v-if="detailData.confirmStateTime" class="t-left font-S14"><span>确认日期：</span>{{  detailData.confirmStateTime | getDate  }}</p>
            <p v-else class="t-left font-S14"><span>确认日期：</span>- </p>
            <p class="t-left font-S14"><span>下单人：</span>{{  detailData.staffInfo||'-'  }}</p>
            <!-- <p class="t-left font-S14"><span>确认人：</span>{{ detailData.createUserName }}</p> -->
            <p class="t-left font-S14"><span>票据状态：</span>{{  detailData.payType ||'-'  }}</p>
            <p class="t-left font-S14"><span>结算方式：</span>{{  detailData.sendListType ||'-'  }}</p>
            <p class="t-left font-S14"><span>随货配备：</span>{{  detailData.annex ||'-'  }}</p>
            <p class="t-left font-S14"><span>备注：</span>{{  detailData.memo||'-'  }}</p>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- 导入 -->
    <el-dialog title="批量导入" @close="cancelImport" :visible.sync="showImport" width="800px" class="importClass">
      <div class="secondStep">
        <p class="line1">数据导入完成，请核对！</p>
        <p class="line2">
          共导入数据 <span> {{  importResult.total  }} </span> 条，导入成功 <span>{{  importResult.ok  }} </span> 条
          <span v-if="importResult.error > 0">，失败<span> {{  importResult.error  }} </span> 条。</span>
        </p>
        <p class="line3" @click="downFailData" v-if="importResult.error > 0">下载导入失败数据</p>
      </div>
    </el-dialog>
    <!-- 结束 -->
    <el-dialog title="调整订单归属人" :visible.sync="modiftAlert" width="500px" :close-on-click-modal='false'>
      <template>
        <div class="task-tips">说明：如果所选订单调整成功后，那么这些订单对应的退货单、应收账单全部归属为转接人员。</div>
        <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label">所属企业：</span>
            <div class="tl">{{ tenantName }}</div>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label">已选笔数：</span>
            <div class="tl">{{ orderSelectedList.length }}</div>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label">指定任务包：</span>
            <el-select v-model="taskGuid" placeholder="请选择" filterable class="fl" style="width: 300px"
              @change="staffChange">
              <el-option v-for="item in taskList" :key="item.guid" :label="item.taskTitle"
                :value="item.guid"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
         <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">指派公司：</span>
            <el-select v-model="assignTenantGuid" filterable placeholder="请选择" class="fl" style="width: 300px" @change="onChangeAssignTenant">
              <el-option
                v-for="item in serviceTenants"
                :key="item.guid" 
                :label="item.tenantName" 
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label" style="color: red">*</span>
            <span slot="label">业务指派人员：</span>
            <el-select v-model="staffGuid" placeholder="请选择业务指派人员" filterable class="fl" style="width: 300px"
              @change="staffChange">
              <el-option v-for="item in staffList" :key="item.guid" :label="item.staffName + '-' + item.mobileNo"
                :value="item.guid"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <el-form label-width="120px" class="demo-ruleForm">
          <el-form-item>
            <span slot="label">所属部门：</span>
            <div class="tl">{{ organisationNames||'-' }}</div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" plain @click="modiftAlert = false">取 消</el-button>
          <el-button size="mini" type="info" @click="sureTaskModify">提 交</el-button>
        </span>
      </template>
    </el-dialog>
    <BatchAdjustmentOrderDialog
      ref="BatchAdjustmentOrderDialogRef"
      @getData="getData"
      @onChangeShowImport="onChangeShowImport"
      @onChangeImportResult="onChangeImportResult"
    ></BatchAdjustmentOrderDialog>
  </div>
</template>

<script>
import areaJson from '../../assets/js/china_address_v4.js';
import BatchAdjustmentOrderDialog from './components/BatchAdjustmentOrderDialog.vue';
export default {
  components: {
    BatchAdjustmentOrderDialog,
  },
  data() {
    return {
      options: areaJson,
      searchShow:false,
      loading: false,
      showImport: false,
      page: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        orderNo: '',
        orderType: '',
        orderState: '',
        startTime: '',
        endTime: '',
        confirmStartTime: '',
        confirmEndTime: '',
        customerName: '',
        franchiseeName: '',
        provinces:[],
        cities:[],
        districts:[],
        confirmState: '',
        isAllocated:null,
        sourceType:null,
        maintainTenantGuid: '',
      },
      orderTypeList: [{ name: "全部", value: "" }, { name: "报货", value: "报货" }, { name: "退货", value: "退货" }],
      orderStateList: [{ name: "全部", value: "" }, { name: "草稿中", value: 10 }, { name: "待审核", value: 20 }, { name: "待出库", value: 30 }, { name: "已驳回", value: 40 }, { name: "已出库", value: 50 }],
      orderTimeList: [],
      confirmStateList: [
        { name: '全部', value: '' },
        { name: '已确认', value: 'Y' },
        { name: '未确认', value: 'N' },
      ],
      comfirmTimeList: [],

      isDistributeList:[
        { name: '全部', value: null},
        { name: '已分配', value: 'Y' },
        { name: '未分配', value: 'N' },
      ],

      tableData: [],
      tableHeight: window.innerHeight - 284,
      contentMainHeight:window.innerHeight - 180,
      drawer: false,
      direction: 'rtl',
      optionsMedical: [],
      detailData: '',
      currentManageStaff: [],
      importResult: {
        total: 0,
        ok: 0,
        error: 0
      },
      fileList: [],
      fullscreenLoading: false,
      modiftAlert: false,
      orderSelectedList: [],
      tenantName: '',
      tenantGuid: '',
      staffList: [],
      staffGuid: '',
      sendTenantList:[],
      organisationNames:'',
      addressList:[],
      taskList:[],
      serviceTenants: [],
      taskGuid:'',
      assignTenantGuid: '',
      taskNo:'',
    };
  },
  watch: {
    searchShow(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 359;
        this.contentMainHeight = window.innerHeight - 270;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 284;
        this.contentMainHeight = window.innerHeight - 180;
        return;
      }
    },
  },
  created() {
    this.getSendTenantList();
  },
  methods: {
    tenantChange(){
        this.page.maintainTenantGuid = '';
        this.getStaffList();
        this.getTaskList();
        this.getServiceTenants()
    },
    getSendTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            console.log( res.data.data)
            self.sendTenantList = res.data.data;
            this.page.tenantGuid =  res.data.data[0].sendTenantGuid;
            this.getServiceTenants()
            this.getData(false);
            this.getStaffList();
            this.getTaskList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    formatOrderState(val) {
      if (!val) return '-';
      let listIten = this.orderStateList.filter((item) => item.value == val);
      console.log(listIten)
      return listIten.length && listIten[0].name || '-';
    },
    empty() {
      this.comfirmTimeList = [];
      this.orderTimeList = [];
      this.addressList = []
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        orderNo: '',
        orderType: '',
        orderState: '',
        startTime: '',
        endTime: '',
        confirmStartTime: '',
        confirmEndTime: '',
        customerName: '',
        franchiseeName: '',
        tenantGuid: '',
        provinces:[],
        cities:[],
        districts:[],
        confirmState: '',
        isAllocated:null,
        sourceType: null,
        maintainTenantGuid: '',
      };
      this.getSendTenantList();
    },
    //获取当天时间
    async getData(flg) {
      if (this.page.staffInfo && !this.page.maintainTenantGuid) {
        this.$message.error('请选择指派公司！');
        return;
      }
      this.loading = true;
      if (flg) {
        this.page.pageIndex = 1;
        // this.comfirmTimeList = [];
        // this.orderTimeList = [];
      }
  
      if (
        this.orderTimeList &&
        Array.isArray(this.orderTimeList) &&
        this.orderTimeList.length > 0 &&
        this.orderTimeList[0] &&
        this.orderTimeList[1]
      ) {
        this.page.startTime = this.$moment(this.orderTimeList[0]).format('YYYY-MM-DD');
        this.page.endTime = this.$moment(this.orderTimeList[1]).format('YYYY-MM-DD');
      } else {
        this.page.startTime = null;
        this.page.endTime = null;
      }
      if (
        this.comfirmTimeList &&
        Array.isArray(this.comfirmTimeList) &&
        this.comfirmTimeList.length > 0 &&
        this.comfirmTimeList[0] &&
        this.comfirmTimeList[1]
      ) {
        this.page.confirmStartTime = this.$moment(this.comfirmTimeList[0]).format('YYYY-MM-DD');
        this.page.confirmEndTime = this.$moment(this.comfirmTimeList[1]).format('YYYY-MM-DD');
      } else {
        this.page.confirmStartTime = null;
        this.page.confirmEndTime = null;
      }
      console.log('address',this.addressList);
      if(this.addressList && this.addressList.length > 0){
        let provinces=[]
        let cities=[]
        let districts=[]
        this.addressList.forEach((item) => {
          item[0]?provinces.push(item[0]):''
          item[1]?cities.push(item[1]):''
          item[2]?districts.push(item[2]):''
        });
        this.page.provinces = [...new Set(provinces)];
        this.page.cities = [...new Set(cities)];
        this.page.districts = [...new Set(districts)];
      }else{
        this.page.provinces = [];
        this.page.cities = [];
        this.page.districts = [];
      }
      console.log('page',this.page);
      await this.api.postJson(`/${serverConfig.msPurchaseService}/sale-order/data/get-pc-list`, this.page).then((res) => {
        this.$nextTick(() => {
          this.$refs.filterTable.doLayout();
        });
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.loading = false;
          this.tableData = res.data.data.records;
          this.page.totalPage = res.data.data.totalPages;
          this.page.totalRows = res.data.data.totalRows;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //详情
    detail(guid) {
      let self = this;
      self.drawer = true;
      self.api.get(`/${serverConfig.msPurchaseService}/sale-order/data/get-mobile-detail?guid=` + guid).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.detailData = res.data.data;
          console.log(res.data);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //批量导入
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    onChangeShowImport(val) {
      this.showImport = val;
    },
    onChangeImportResult(val) {
      this.importResult = val;
    },
    changeFile(file, fileList) {
      this.fileList = [];
      this.fullscreenLoading = true;
      let formData = new FormData();
      formData.append('file', file.file);//传文件
      formData.append('clientTenantGuid', this.page.tenantGuid);
      let url = `/${serverConfig.msPurchaseService}/sale-order/import`
      this.api.postFile(url, formData).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.importResult = res.data.data;
          this.showImport = true;
          this.getData(true);

        } else {
          this.$message({
            type: 'warning',
            message: res.data.msg
          })
        }
      })
    },
    generateUUID() {
      var d = new Date().getTime();
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
      }
      var uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
      return uuid;
    },
    //导出订单
    async report() {
      await this.getData(true);
      if (!this.tableData.length) {
        this.$message.error('没有可导出的数据。');
        return;
      }
      let self = this;
      let req = JSON.parse(JSON.stringify(self.page));
      req.pageSize = -1;
      this.fullscreenLoading = true;
      let itemTenant = this.sendTenantList.filter(item => item.sendTenantGuid === this.page.tenantGuid)
      self.api.postJsonD(`/${serverConfig.msPurchaseService}/sale-order/export`, req).then(res => {
        this.fullscreenLoading = false;
        let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        let fileName = itemTenant[0].sendTenantName + '-销售订单-' + this.$moment(new Date()).format('YYYYMMDD');
        let objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a')
        link.download = fileName;
        link.href = objectUrl;
        link.click();
      });
    },
    modifyPerson() {
      if (this.orderSelectedList.length == 0) {
        this.$message.error('请选择其中一条或多条记录')
        return;
      }
      this.staffGuid = '';
      this.taskGuid = '';
      this.taskNo = '';
      this.organisationNames ='';
      this.assignTenantGuid = '';
      this.modiftAlert = true;
    },
    onShowBatchAdjustmentOrderDialog() {
      const data = {
        tenantGuid: this.page.tenantGuid,
        sendTenantList: this.sendTenantList,
        fullscreenLoading: this.fullscreenLoading,
      }
      this.$refs.BatchAdjustmentOrderDialogRef?.open(data);
    },
    //选择记录
    handleSelectionChange(v) {
      this.orderSelectedList = v;
      this.tenantGuid = this.page.tenantGuid;
      this.sendTenantList.forEach(item=>{
        if(this.tenantGuid==item.sendTenantGuid){
          this.tenantName = item.sendTenantName;
        }
      })

      // this.tenantName = JSON.parse(localStorage.userInfo).tenantName;
    },
    async getServiceTenants() {
      const params = {
        tenantGuid: this.page.tenantGuid,
        isService: false,
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/tenant/data/get-service-tenants`,
        params
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.serviceTenants = data.data;
      this.getStaffList(this.assignTenantGuid);
    },
    getTaskList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid:this.page.tenantGuid,
        orderColumn: 'create_time',
        state: ['已派发', '部分结算'],
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data.records) {
            self.taskList = res.data.data.records;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getStaffList(val) {
      const tenantGuid = val || this.page.tenantGuid;
      this.api.get(
        `/${serverConfig.msPersonnelService}/staff/get-staff-by-tenantGuid?tenantGuid=` + tenantGuid
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.staffList = res.data.data;
          console.log(this.staffList)
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    onChangeAssignTenant(val) {
      this.assignTenantGuid = val;
      this.staffGuid = '';
      this.getStaffList(val);
    },
    staffChange(){
      let sraffGuid = this.staffGuid;
      this.staffList.forEach(item => {
       if (sraffGuid == item.guid) {
          this.organisationNames = item.organisationNames;
        }
      })
    },
    sureTaskModify() {
      if (!this.assignTenantGuid) {
        this.$message.error('请选择指派公司')
        return;
      }
      if (!this.staffGuid) {
        this.$message.error('请选择业务指派人员')
        return;
      }
      // 委托方药企GUID：clientTenantGuid，
      // 转接人员所属企业GUID：tenantGuid
      // 转接企业是否为三方服务商Y 是，N 否：isNewService
      const isNewService = this.serviceTenants.find(item => item.guid === this.assignTenantGuid)?.isNewService
      let req = {
        orderGuids: [],
        staffGuid: '',
        staffName: '',
        staffPhone: '',
        taskGuid:'',
        taskNo:'',
        clientTenantGuid: this.page.tenantGuid,
        tenantGuid: this.assignTenantGuid,
        isNewService,
      }
      let orderSelectedList = this.orderSelectedList;
      let staffList = this.staffList
      let sraffGuid = this.staffGuid;
      req.taskGuid=this.taskGuid
      req.taskNo = this.taskList.find(item => item.guid === this.taskGuid)?.taskNo;
      orderSelectedList.forEach(item => {
        req.orderGuids.push(item.guid);
      })
      staffList.forEach(item => {
        if (sraffGuid == item.guid) {
          req.staffName = item.staffName;
          req.staffPhone = item.mobileNo;
          req.staffGuid = item.guid;
        }

      })
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msPurchaseService}/sale-order/data/adjust-order-staff`, req).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success('调整成功！')
          this.modiftAlert = false;
          this.getData()
        } else {
          this.$message.error(res.data.msg);
        }
      });

    },
    //关闭弹窗
    cancelImport() {
      this.showImport = false;
    },
    //下载失败数据
    downFailData() {
      let req = {
        tenantGuid: this.importResult.tenantGuid
      }
      this.api.get(`/${serverConfig.msPurchaseService}/sale-order/get-import-error-data`, req).then(res => {
        if (res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) { 
          this.$message.error(res.data.msg);
          return;
        }
        this.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
      });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
    },
    //自动分配
    automaticAllocation(){
      let self = this;
      if (self.orderSelectedList.length == 0) {
        self.$message.error('请先勾选数据！');
        return;
      }
      let orderGuids = [];
      self.orderSelectedList.forEach(i=>{
        orderGuids.push(i.guid)
      })
      let query = {
        tenantGuid:self.page.tenantGuid,
        orderGuids,
        orderType:'1'
      }
      self.$confirm('自动分配后，原有已分配的数据将重置，重新进行新的分配，确定此操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msPurchaseService}/sale-order/order-auto-allocate`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.orderSelectedList = [];
              self.$message.success('分配成功');
              self.getData(true);
              self.fullscreenLoading = false;
            } else {
              self.fullscreenLoading = false;
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作',
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
<style scoped>

.offer-information {
  border-top: 10px solid #dcdfe6;
  /* border-bottom: 10px solid #dcdfe6; */
}

.variety-information {
  /* padding-top: 10px; */
  border-top: 10px solid #dcdfe6;
}

.variety-list {
  padding: 15px;
  /* border-bottom: 1px solid #dcdfe6; */
  /* border-radius: 6px; */
  overflow: hidden;
}

.total-top {
  padding-top: 15px;
  border-top: 1px solid #dcdfe6;
}

.variety-left {
  width: 150px;
  height: 100px;
  margin-top: 20px;
  /* border-bottom: 1px solid #dcdfe6; */
  border-radius: 6px;
}

.variety-left img {
  width: 150px;
  height: 100px;
  border-radius: 6px;
}

.pic-item {
  overflow: hidden;
}


.importClass .secondStep {
  margin-top: 50px;
  height: 200px;
}

.importClass .secondStep .line1 {
  font-size: 20px;
}

.importClass .secondStep .line2 {
  font-size: 16px;
}

.importClass .secondStep .line2 span {
  color: #4fa1a4;
}

.importClass .secondStep .line3 {
  text-decoration: underline;
  cursor: pointer;
}

.upload-demo {
  display: inline-block;
  margin: 0 10px;
}

.task-tips {
  font-size: 14px;
  font-style: normal;
  font-weight: normal;
  color: red;
  text-align: left;
  margin-bottom: 5px;
  padding: 0 35px;
}

.tl {
  text-align: left;
}
.pic-w22 {
  width: 22px;
  height: 22px;
}
.pl30 {
  padding-left: 30px;
}
/deep/ .el-cascader__tags {
  display: flex;
  flex-wrap: nowrap;
}
/deep/ .el-cascader__tags .el-tag>span {
  text-overflow: clip;
}
/deep/ .el-tag--mini {
  width:60px
}
/deep/ .el-cascader__search-input  {
  min-width:30px!important;
  margin: 2px 0 2px 5px!important;
}
/deep/ .el-drawer__body {
  overflow: auto;
}

/deep/ .el-drawer__header{
  font-size: 18px;
  color: #333;
}
.search-area-div{
  width: 78px;
  text-align: right;
}
.ipt-sty{
  flex: 1;
}
.el-col-6 {
  display: flex;
}
.mt15 {
  margin-top: 4px;
}
.el-col-8{
  display: flex;
  margin-bottom: 15px;
  justify-content: flex-end;
}
</style>